<template>
    <div class="doclistblock">
        <a-button class="editDocBtn" type="primary" @click="handleNew('adddoc')" v-if="parentHook == '0'">
                <a-icon type="plus" />普通文档
        </a-button>
        <a-button class="editDocBtn" type="primary" @click="handleNew('addapi')"  v-if="parentHook == '3'" >
                <a-icon type="plus" />API文档
        </a-button>
        <!-- 文档列表 -->
        <a-table  :columns="columns" :data-source="tableData" 
            :pagination="false" :loading="tloading" rowKey="id" size="middle" :scroll="{ x: clientWidth}">
            <template slot="operation" slot-scope="text, record">
                <router-link class="tableLink"  :to="{path:record.type == '0' ? 'editdoc' : 'editapi',query: {id: record.id,}}">编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
<!-- 
            <template slot="status" slot-scope="text">
               <span v-if="text == '0'">
                   未发表
               </span>
               <span v-else-if="text == '1'">
                   已发表
               </span>
               <span v-else>
                   --
               </span>
            </template> -->
            <template slot="type" slot-scope="text">
               <span v-if="text == '0'">
                   普通文档
               </span>
               <span v-else-if="text == '1'">
                   API文档
               </span>
               <span v-else>
                   --
               </span>
            </template>
        </a-table>

    </div>
</template>
<script>

const columns = [
    
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            return  index + 1;
        }
    },
    {
        title: "文档类型",
        dataIndex: "type",
        scopedSlots: { customRender: 'type' },
        align: "center",
        width:60
    },
    // {
    //     title: "版本号",
    //     dataIndex: "version",
    //     align: "center",
    //     width:120
    // },
    // {
    //     title: "标签",
    //     dataIndex: "tags",
    //     align: "center",
    //     width:120
    // },
    // {
    //     title: "菜单编码",
    //     dataIndex: "menucode",
    //     align: "center",
    //     width:120
    // },
    // {
    //     title: "分类名称",
    //     dataIndex: "name",
    //     align: "center",
    //     width:120
    // },
    {
        title: "标题",
        dataIndex: "title",
        align: "center",
        width:200,
        ellipsis:true,
    },
    // {
    //     title: "描述",
    //     dataIndex: "desc",
    //     align: "center",
    //     ellipsis:true,
    //     width:200
    // },
    // {
    //     title: "发布状态",
    //     dataIndex: "status",
    //     scopedSlots: { customRender: 'status' },
    //     align: "center",
    //     width:50
    // },
    // {
    //     title: "正文",
    //     dataIndex: "body",
    //     align: "center",
    //     width:120
    // },
    // {
    //     title: "创建人",
    //     dataIndex: "createuser",
    //     width:100
    // },
    // {
    //     title: "创建时间",
    //     dataIndex: "createtime",
    //     width:200
    // },
    {
        title: "更新人",
        align: 'center',
        dataIndex: "updatetuser",
        width:80
    },
    {
        title: "更新时间",
        align: 'center',
        dataIndex: "updatetime",
        width:120
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 90,
        scopedSlots: { customRender: 'operation' },
    },

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            clientWidth:800,
            ordercoloum:'total',
            orderstr:'desc',
            platforms:[],
            menucode:'',
            parentHook:''
        };
    },
    methods: {
        handleNew(type){
            this.$router.push({
                path: type,
                query: {
                    id:'',
                }
            });
        },
        handleDelete(item){
            let that = this;
            that.$store.dispatch({
                type: "open/deletedoc",
                params: {id: item.id}
            }).then((res) => {
                if (res.status == '200') {
                    that.getAppSumData()
                }
            });
            
        },
        getAppSumData(menuItem){
            let that = this;
            if(menuItem){
                this.parentHook = menuItem.pHook;
                this.menucode = menuItem.cMenucode;
            }
            let params = {
                menucode:that.menucode,
                urlparams:false
            };
            that.$store.dispatch({
                type: "open/selectdoclist",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    this.tableData = res.data.data;
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
 
    },
    components:{
        
    },
    mounted(){
        
    },
};
</script>
<style scoped>
   
    .tableLink{
        margin-right: 10px;
    }

    .doclistblock{
        width:100%;
        height: auto;
        margin-top: 28px;
        padding: 0 20px;
    }

.editDocBtn{
        position: absolute;
        right: 0;
        top: 10px;
    }
</style>

